import { Component, OnInit,Input,TemplateRef } from '@angular/core';

@Component({
  selector: 'component-splited-header',
  templateUrl: './splited-header.component.html',
  styleUrls: ['./splited-header.component.css','../../../styles.scss']
})
export class SplitedHeaderComponent implements OnInit {
  @Input() h2Content: string = '';
  @Input() paragraphTemplate: TemplateRef<any>|null;
  constructor() { 
    this.paragraphTemplate = null;
  }

  ngOnInit(): void {
    
  }

}
